// ============================================================================
//  Multi-tenancy: every subdomain maps to a tenant id. All data in Supabase is
//  scoped by this id so the three customers stay separated in one project.
//
//    mayasofterp.shivmayatechsolutions.com → 'mayasoft'
//    embercore.shivmayatechsolutions.com   → 'embercore'
//    shivmaya.shivmayatechsolutions.com    → 'shivmaya'
//
//  To onboard a new customer: create their subdomain and add a line here
//  (the key is the first label of the hostname, the value is the tenant id).
//  See multi-tenant runbook.
// ============================================================================

const TENANT_MAP = {
  mayasofterp: 'mayasoft',
  embercore: 'embercore',
  shivmaya: 'shivmaya',
};

// Default tenant when the host isn't a known subdomain (localhost, previews).
// Keeps local dev pointed at the original data set.
const DEFAULT_TENANT = 'mayasoft';

let cached = null;

export function getTenantId() {
  if (cached) return cached;

  // Manual override for local testing of a specific tenant:
  //   localStorage.setItem('erp_tenant_override', 'erp1')
  try {
    const override = localStorage.getItem('erp_tenant_override');
    if (override) { cached = override; return cached; }
  } catch { /* ignore */ }

  const host = (typeof window !== 'undefined' && window.location && window.location.hostname) || '';
  const sub = host.split('.')[0];
  cached = TENANT_MAP[sub] || DEFAULT_TENANT;
  return cached;
}

// Human-friendly label (handy for showing in the UI / admin switcher later).
export function getTenantLabel() {
  return getTenantId();
}
